import { call, put, takeLatest } from 'redux-saga/effects';

import { getSelfInsuranceTaxes } from '../../services/API';
import {
  actionTypes,
  requestSelfInsuranceTaxesSuccess,
  requestSelfInsuranceTaxesFailure,
} from './actions';

function* getData() {
  const response = yield call(getSelfInsuranceTaxes);
  if (response.isOk) {
    yield put(requestSelfInsuranceTaxesSuccess(response.data));
  } else {
    yield put(requestSelfInsuranceTaxesFailure(response.error));
  }
}

export default function* selfInsuranceTaxesSaga() {
  yield takeLatest(actionTypes.SELF_INSURANCE_TAXES_REQUEST_START, getData);
}
